module.exports = "/_next/static/images/be-prepared-07adc9a312ae27bfd55d25e6e7779237.svg";